@import ../../styles/helpers

.friendLink
    transition: transform 0.1s
    background-color: $dark_contrast
    aspect-ratio: 1/1
    position: relative
    border-radius: 100%
    display: flex
    justify-content: center
    align-items: center
    width: 65px
    height: 65px
    svg
        fill: white
        
        width: $icon_size
        height: $icon_size